import { UseAxiosResult } from 'axios-hooks'
import { useAxiosClient } from './configs/axios-setup'

export interface AdmSequence {
  id: number
  name: string
  seriesId: number
  tunnelLocationId: number
  duration: number
  series: {
    id: number
    name: string
  }
  tunnelLocation: {
    id: number
    name: string
  }
  pointCount: number
}

export interface AdmSequencePoint {
  id: number
  sequenceId: number
  pointOrder: number
  rideHeight: number | null
  frontHeight: number | null
  rearHeight: number | null
  roll: number | null
  steer: number | null
  input1: number | null
  input2: number | null
  input3: number | null
  input4: number | null
  yaw: number | null
  roadSpeed: number | null
  airSpeed: number | null
  tareOn: boolean
  sampleTimeSeconds: number | null
  dataOn: boolean
  atd: number | null
}

export const useGetAdmSequencesForSeries = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      method: 'GET'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  const refetch = seriesId => {
    return doFetch({
      url: `/AdmSequences/series/${seriesId}`
    })
  }

  return [
    { data, loading, error },
    refetch,
    () => {
      return
    }
  ]
}

export const useGetAdmSequencesForTeam = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      url: '/AdmSequences/team-sequences',
      method: 'GET'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  const refetch = () => {
    return doFetch({
      url: '/AdmSequences/team-sequences'
    })
  }

  return [
    { data, loading, error },
    refetch,
    () => {
      return
    }
  ]
}

export const useGetAdmSequencePoints = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      method: 'GET'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  const refetch = sequenceId => {
    return doFetch({
      url: `/AdmSequences/${sequenceId}/points`
    })
  }

  return [
    { data, loading, error },
    refetch,
    () => {
      return
    }
  ]
}
